<template>
    <div>
        
        <div v-if="leadTitleItem && leadTitleItem.value" class="lead-article-container">            
            <div class="lead-article">
                <h1 :class="leadTitleItem.sectionClass">{{leadTitleItem.value}}</h1>
                <p class="lead">{{leadText}}</p>
            </div>
            <div class="svg-container" v-if="leadImageSvg"><img :src="require(`../assets/theme/${getReseller.id}/images/${leadImageSvg}.svg`)" /></div>
        </div>
    </div>    
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    methods: {
        
    },
    computed: {
        ...mapGetters({      
            getReseller: 'reseller/getResellerInfo'
        }),
        leadImageExt() {
        if (this.getReseller.leadImageExt)
            return this.getReseller.leadImageExt
        else
            return `jpg`
        },
        leadImage () {
        if (this.getReseller.leadImage)
            return this.getReseller.leadImage
        else
            return 'gadgets'
        },
        leadImageSvg () {
        if (this.getReseller.leadImageSvg)
            return this.getReseller.leadImageSvg
        else
            return null
        },        
        leadConfig() {
            return this.leadContent(this.$route.path);
        },
        leadTitle() {
            return this.$textManager.getText("leadTitle", this.$route.name)
        },
        leadTitleItem() {
            const textItem = this.$textManager.getTextItem("leadTitle", this.$route.name)
            if (textItem) {
                return textItem;
            } else {
                return this.$textManager.getEmpty();    
            }
        },
        leadText() {
            return this.$textManager.getText("leadText", this.$route.name)
        }
    }    
}

</script>

<styles scoped lang="scss">
.middle-title {
    margin: auto 0;
}
</styles>